export const PEDIATRIC_INDICATOR_OPTIONS = [
  { label: 'Select', value: '', isHidden: true },
  { label: 'Select All', value: '' },
  { label: 'Over 18', value: false },
  { label: 'Under 18', value: true },
];

export const PEDIATRIC_INDICATOR_OPTIONS_CUSTOM_POP = [
  { label: 'Select', value: '', isHidden: true },
  { label: 'Select All', value: '' },
  { label: 'Over 18', value: 'greater_than_18' },
  { label: 'Under 18', value: 'less_than_18' },
];
